// Mappa live tecnici con react-leaflet e aggiornamenti WebSocket
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import { Card, CardHeader, CardTitle } from '../../../components/ui/Card'
import { Avatar } from '../../../components/ui/Avatar'
import { useRealtimeStore } from '../../../stores/realtime.store'

// Fix icone Leaflet con Vite
delete (L.Icon.Default.prototype as unknown as Record<string, unknown>)._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
})

// Icona tecnico personalizzata
function createTechnicianIcon(isCheckedIn: boolean) {
  return L.divIcon({
    html: `<div style="
      width: 32px; height: 32px;
      background: ${isCheckedIn ? 'var(--fc-primary, #0F52BA)' : '#6B7280'};
      border: 3px solid white;
      border-radius: 50%;
      box-shadow: 0 2px 4px rgba(0,0,0,0.3);
      display: flex; align-items: center; justify-content: center;
    "></div>`,
    className: '',
    iconSize: [32, 32],
    iconAnchor: [16, 16],
  })
}

export function TechnicianMap() {
  const techPositions = useRealtimeStore((s) => s.technicianPositions)
  const positions = Object.values(techPositions)

  return (
    <Card noPadding className="relative">
      <div className="p-4">
        <CardHeader className="mb-0">
          <CardTitle>Posizioni tecnici live</CardTitle>
          <span className="flex items-center gap-1 text-xs text-[var(--fc-foreground-muted)]">
            <span className="h-2 w-2 rounded-full bg-[var(--fc-success)] animate-pulse" aria-hidden="true" />
            {positions.filter((p) => p.isCheckedIn).length} in campo
          </span>
        </CardHeader>
      </div>

      <div className="h-[300px] relative">
        <MapContainer
          center={[41.9028, 12.4964]}
          zoom={6}
          style={{ height: '100%', width: '100%' }}
          className="rounded-b-lg"
          aria-label="Mappa posizioni tecnici"
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {positions.map((tech) => (
            <Marker
              key={tech.userId}
              position={[tech.coords.lat, tech.coords.lng]}
              icon={createTechnicianIcon(tech.isCheckedIn)}
            >
              <Popup>
                <div className="flex items-center gap-2 p-1">
                  <Avatar name={tech.name} size="sm" online={tech.isCheckedIn} />
                  <div>
                    <p className="text-sm font-semibold">{tech.name}</p>
                    <p className="text-xs text-gray-500">
                      {tech.isCheckedIn ? 'In campo' : 'Non disponibile'}
                    </p>
                  </div>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>

      {positions.length === 0 && (
        <div className="pointer-events-none absolute inset-0 flex items-end justify-center rounded-b-lg pb-4">
          <span className="rounded-full bg-[var(--fc-surface)]/90 px-3 py-1 text-xs text-[var(--fc-foreground-muted)] shadow">
            Nessun tecnico in campo
          </span>
        </div>
      )}
    </Card>
  )
}
